module.exports = __webpack_public_path__ + "static/media/18ECA51.4c03a246.jpg";